import { Injectable, OnDestroy } from '@angular/core';
import {
  fromEvent,
  merge,
  Subscription,
  startWith,
  switchMap,
  throttleTime,
  timer
} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InactivityService implements OnDestroy {

  private readonly inactivityTimeout = 60 * 60 * 1000;
  private activitySubscription?: Subscription;

  startWatching(onInactivity: () => void): void {
    console.log('InactivityService: Iniciando monitoreo de inactividad...');
    // Evita registrar múltiples escuchas.
    if (this.activitySubscription) return;

    const mouseMove$ = fromEvent(document, 'mousemove').pipe(
      throttleTime(1000)
    );

    const activity$ = merge(
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'touchstart'),
      fromEvent(document, 'pointerdown'),
      mouseMove$
    );

    this.activitySubscription = activity$
      .pipe(
        startWith(null),
        switchMap(() => timer(this.inactivityTimeout))
      )
      .subscribe(() => {
        this.stopWatching();
        onInactivity();
      });
  }

  stopWatching(): void {
    this.activitySubscription?.unsubscribe();
    this.activitySubscription = undefined;
  }

  ngOnDestroy(): void {
    this.stopWatching();
  }
}
